/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTimeline.defs'
export { main as default } from './getTimeline.defs'
